module.exports = __webpack_public_path__ + "img/large7.16926da1.jpg";